import { useEffect } from 'react'

import Loading from '@/components/Loading'

export default function LogoutPage() {
    useEffect(() => {
        // Clear any in-progress onboarding draft so the next login doesn't
        // surface "Resume setup?" for a user who already finished or who
        // intentionally signed out.
        try { sessionStorage.removeItem('brightpath-onboarding') } catch {}

        // Navigate directly to the API logout endpoint.
        // The browser sends the cookie automatically (same-site navigation).
        // The server clears the cookie and we redirect to /login afterward.
        window.location.href = `${import.meta.env.VITE_API_URL}/auth/logout`
    }, [])

    return (
        <div className='flex flex-col items-center justify-center'>
            <Loading mode='block' text='Logging out...' textClassName='text-brand-600' />
        </div>
    )
}
